import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import rulesReducer from '../store/rules/rulesSlice';
import ruleSchedulesReducer from '../store/rules/ruleSchedulesSlice';
import powerManagementSettingsReducer from '../store/rules/settingsSlice';
import menuNodesReducer from '../store/positions/menuNodesSlice';
import monitorsReducer from '../store/positions/monitorsSlice';
import positionsReducer from '../store/positions/positionsSlice';
import sitesReducer from '../store/positions/sitesSlice';
import userReducer from '../store/users/userSlice';
import usersReducer from '../store/users/usersSlice';
import reportsReducer from '../store/data-export/reportsSlice';
import reportSchedulesReducer from '../store/data-export/reportSchedulesSlice';
import reportTemplatesReducer from '../store/data-export/reportTemplatesSlice';
import csvsReducer from '../store/data-export/csvsSlice';
import customersReducer from '../store/data-export/customersSlice'
import mapSettingsReducer from '../store/devices/mapSettingsSlice';
import wrxOptionsReducer from '../store/rules/wrxOptionSlice';
import warningReducer from '../store/common/warningSlice';
import firmwareReducer from '../store/positions/firmwareSlice';
import filterStatusReducer from '../store/positions/filterStatusSlice';

export const store = configureStore({
  reducer: {
    rules: rulesReducer,
    ruleSchedules: ruleSchedulesReducer,
    powerManagementSettings: powerManagementSettingsReducer,
    menuNodes: menuNodesReducer,
    monitors: monitorsReducer,
    positions: positionsReducer,
    sites: sitesReducer,
    user: userReducer,
    users: usersReducer,
    reports: reportsReducer,
    reportSchedules: reportSchedulesReducer,
    reportTemplates: reportTemplatesReducer,
    csvs: csvsReducer,
    customers: customersReducer,
    mapSettings: mapSettingsReducer,
    wrxOptions: wrxOptionsReducer,
    warnings: warningReducer,
    firmware: firmwareReducer,
    filterStatus: filterStatusReducer,
  },
  // set middleware values manually here to disable in dev mode
  // causes a lot of lag in development so is useful to disable and see how it would run in production
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
